import { compose } from 'redux';
import { connect } from 'react-redux';
import OpeningView from '../../../common/opening/OpeningView';
import { narrateReset, stopAudio } from '../../../common/audio/audioActions';
import { unmountScreen } from '../../../common/screen/screenActions';
import { narrateOpeningScreen } from './WROpeningActions';
import WR_AUDIO_INSTRUCTIONS from '../../wrConstants';
import selectors from '../../../rootSelectors';
import { goToModel } from '../../../common/navigation/navigationActions';
import { WR } from '../../../constants/measure';
import AvatarView from '../../../common/avatar/avatarView';
import withAvatar from '../../../common/avatar/withAvatar';

const mapStateToProps = (state) => ({
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isNextButtonActive: selectors.getIsNextButtonActive(state),
});

const mapDispatchToProps = (dispatch) => ({
    onNext: () => {
        dispatch(goToModel(WR.KEY));
    },
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(narrateReset());
        dispatch(unmountScreen());
    },
    narrateScreen: () => {
        dispatch(narrateOpeningScreen(WR_AUDIO_INSTRUCTIONS.wrOpeningInstruction));
    },
});

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.CENTER,
    instructions: WR_AUDIO_INSTRUCTIONS.wrOpeningInstruction,
});

const WROpeningContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(OpeningView);

export default WROpeningContainer;
